module.exports = __webpack_public_path__ + "img/portfolio10.3cf8323c.jpg";